import { createSharedComposable } from '@src/app/utils/VueUse/createSharedComposable';
import { ref } from '@vue/composition-api';

function elementsVisibilityObserver() {
    const elements = ref<(string)[]>([]);

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            const id = (entry.target as HTMLElement).dataset.id as string;

            if (entry.isIntersecting) {
                if (!elements.value.includes(id)) {
                    elements.value.push(id);
                }
            } else {
                const index = elements.value.indexOf(id);

                if (index >= 0) {
                    elements.value.splice(index, 1);
                }
            }
        }
    });

    return { observer, elements };
}

export const eventsObserver = createSharedComposable(elementsVisibilityObserver);

export const oddsObserver = createSharedComposable(elementsVisibilityObserver);
